var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1269,
    height: 1270,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2342,
    y: 270,
    width: 1269,
    height: 1270
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2478,
    y: 584,
    width: 679,
    height: 680
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2478,
    y: 584,
    width: 679,
    height: 680
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2478,
    y: 584,
    width: 679,
    height: 680
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2804,
    y: 584,
    width: 681,
    height: 680
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2804,
    y: 584,
    width: 681,
    height: 680
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2804,
    y: 584,
    width: 681,
    height: 680
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2342 -270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2345 904.5C2345 555.18 2628.18 272 2977.5 272 3326.82 272 3610 555.18 3610 904.5 3610 1253.82 3326.82 1537 2977.5 1537 2628.18 1537 2345 1253.82 2345 904.5Z",
    fill: "#F6F6F6",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.938 629.143 360.938 100.379 423.887 163.328C432.09 171.531 445.39 171.531 453.593 163.328 461.796 155.125 461.796 141.825 453.593 133.622L354.572 34.6573C346.76 26.4541 333.777 26.1375 325.573 33.95 325.332 34.18 325.096 34.4158 324.866 34.6573L225.916 133.607C217.713 141.42 217.396 154.403 225.209 162.606 225.439 162.848 225.675 163.084 225.916 163.314 233.729 171.517 246.712 171.834 254.915 164.021 255.156 163.791 255.392 163.555 255.622 163.314L318.536 100.4 318.536 629.143C318.536 640.861 328.035 650.362 339.755 650.362 351.474 650.362 360.973 640.861 360.973 629.143Z",
    fill: "#404040",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00147 2478 584)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3123.53 633.931 3123.53 1163.47 3060.49 1100.43C3052.27 1092.22 3038.95 1092.22 3030.74 1100.43 3022.52 1108.65 3022.52 1121.97 3030.74 1130.18L3129.91 1229.29C3137.73 1237.51 3150.73 1237.82 3158.95 1230 3159.19 1229.77 3159.43 1229.53 3159.66 1229.29L3258.75 1130.2C3266.97 1122.37 3267.28 1109.37 3259.46 1101.15 3259.23 1100.91 3258.99 1100.68 3258.75 1100.45 3250.93 1092.23 3237.92 1091.91 3229.71 1099.74 3229.47 1099.97 3229.23 1100.2 3229 1100.45L3166 1163.45 3166 633.931C3166 622.195 3156.48 612.681 3144.75 612.681 3133.01 612.681 3123.5 622.195 3123.5 633.931Z",
    fill: "#404040",
    fillRule: "nonzero",
    fillOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swap_icon.72afe286fa8ded65bbc0f29c02bd5e83.svg";
export { ForwardRef as ReactComponent };